import { Link } from 'react-router-dom';
import { PageLayout } from '@/pages/PageLayout';

const H2 = ({ children }) => (
  <h2 className="text-xl font-semibold text-slate-900 dark:text-white pt-2">{children}</h2>
);

export function TermsOfService() {
  return (
    <PageLayout title="Terms of Service">
      <p>
        These Terms of Service (&quot;Terms&quot;) govern your use of AssistlyAI, an AI-powered
        assistant available through WhatsApp. By using AssistlyAI, you agree to these Terms.
      </p>

      <div className="space-y-4">
        <H2>The service</H2>
        <p>
          AssistlyAI helps you manage your workday through natural conversation — including
          scheduling, reminders, notes and summaries, calendar-related tasks, multilingual support
          (including English, Hindi, and Hinglish), and optional document or image uploads so you can
          later ask for details (for example from a ticket or PDF). Features may change as we improve
          the product.
        </p>
        <p>
          AssistlyAI is not a replacement for professional advice (legal, medical, financial, or
          otherwise). You are responsible for how you use outputs from the assistant.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Eligibility and account</H2>
        <p>
          You must be able to form a binding contract in your jurisdiction and comply with WhatsApp&apos;s
          terms. You are responsible for the accuracy of information you provide and for keeping your
          WhatsApp account secure.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Subscriptions and pricing</H2>
        <p>
          Paid plans, pricing (including amounts in INR where applicable), billing cycles, and taxes
          are as shown on our website or communicated to you at purchase. Failure to pay may result
          in suspension or termination of access to paid features.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Acceptable use</H2>
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Use the service for unlawful, harmful, or fraudulent activity.</li>
          <li>Attempt to reverse engineer, overload, or disrupt the service or others&apos; use of it.</li>
          <li>Send content that infringes others&apos; rights or violates applicable law.</li>
          <li>Use the service to generate or distribute spam or malware.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <H2>Disclaimer</H2>
        <p>
          The service is provided &quot;as is&quot; to the fullest extent permitted by law. We do not
          guarantee uninterrupted or error-free operation. AI-generated responses may be incomplete or
          incorrect; you should verify important information.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Limitation of liability</H2>
        <p>
          To the maximum extent permitted by applicable law, AssistlyAI and its team will not be
          liable for indirect, incidental, special, consequential, or punitive damages, or for loss of
          profits, data, or goodwill, arising from your use of the service.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Suspension and termination</H2>
        <p>
          We may suspend or terminate access if you violate these Terms or if we need to do so for
          legal, security, or operational reasons. You may stop using the service at any time.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Governing law</H2>
        <p>
          These Terms are governed by the laws of India, without regard to conflict-of-law
          principles. Courts in India shall have exclusive jurisdiction, subject to mandatory
          consumer protections where they apply.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Contact</H2>
        <p>
          For questions about these Terms, use our{' '}
          <Link to="/contact" className="text-[#25D366] hover:underline">
            Contact
          </Link>{' '}
          page or reach us on WhatsApp using the number shown on the website.
        </p>
      </div>
    </PageLayout>
  );
}
